export const TIMEZONE = 'Europe/Madrid';
export function newDateBuilder(date) {
    if (!date)
        return null;
    if (diffTimeZone()) {
        let formatDate = date.replaceAll('/', '-').replaceAll(' ', 'T');
        let offset = getTimeZone(date).substring(3);
        return new Date(formatDate.concat(offset));
    }
    else {
        return new Date(date);
    }
}
function diffTimeZone() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone === TIMEZONE ? false : true;
}
function getTimeZone(date) {
    const formatter = new Intl.DateTimeFormat([], {
        timeZone: 'Europe/Madrid',
        timeZoneName: 'longOffset'
    });
    return formatter.formatToParts(new Date(date))
        .find((formatted) => formatted.type === 'timeZoneName')['value'];
}
//# sourceMappingURL=new-date-builder.js.map